<template>
	<el-upload action="#" class="cos-uploader" :show-file-list="false" list-type="picture-card" :before-upload="beforeUpload">
		<slot>上传文件</slot>
	</el-upload>
</template>
<script>
import { TencentCOS } from "@/assets/js/cos";
export default({
	name: "cos-upload",
    props: {
        config:{
            type: Object,
            default: {
                uploadDirect: true, // 是否直接上传
            } 
        }
    },
	components: {
	},
	data() {
		return {
		};
	},
	methods: {
        simplifyUpload(file, progressHandler, successHandler, errorHandler){
			this.cos.putObject({
				file: file,
				onProgress: (info)=> {
					progressHandler && progressHandler(info)
				},
				onUploadFailed: (err)=>{
					errorHandler && errorHandler(err);
				},
				onUploadSuccess: (info, savekey)=>{
					let url = info.Location
					url = this.cos.replaceUrl2COSCDN(url)
					successHandler && successHandler({
						url: url,
						file: file,
						name: file.name,
						size: file.size,
						savekey: savekey
					})
				}
			})
        },
		beforeUpload(file){
            if(this.config.uploadDirect){
                this.cos.putObject({
					file: file,
					onTaskReady: (tid)=> {
						console.log('onTaskReady', tid);
					},
					onTaskStart: (info)=> {
						console.log('onTaskStart', info);
					},
					onProgress: (info)=> {
						console.log(info);
					},
					onUploadFailed: (err)=>{
						console.log(err)
					},
					onUploadSuccess: (info, savekey)=>{
						let url = info.Location
						url = this.cos.replaceUrl2COSCDN(url)
						this.$emit("onUploadSuccess", {
							url: url,
							file: file,
							name: file.name,
							size: file.size,
							savekey: savekey
						})
					}
				})
            }else{
                this.$emit("beforeUpload", file)
                return false;
            }
		}
	},
	created(){
		this.cos = new TencentCOS()
		this.cos.init({ userid: this.loadAccount().userid }, this)
	}
});
</script>
<style scoped>
.cos-uploader{
	width: 202px;
	height: 28px;
	line-height: 28px;
	border: 1px solid rgba(221, 221, 221, 0.63);
	border-radius: 4px;
	cursor: pointer;
	position: relative;
}
.cos-uploader /deep/ .el-upload--picture-card{
	background-color: #fff;
}
.cos-uploader /deep/ .el-upload--picture-card{
	width: 100%;
	height: 100%;
}
</style>
